import Modalbox from '../utils/_modal-box'

export default function VideoModal () {
  new Modalbox('.open-video-modal')
  new Modalbox('.play-btn')
}